import { render, staticRenderFns } from "./BlockVideoRecordScreen.vue?vue&type=template&id=64c829ec"
import script from "./BlockVideoRecordScreen.vue?vue&type=script&lang=js"
export * from "./BlockVideoRecordScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports